import { render, staticRenderFns } from "./aftersaleDetails.vue?vue&type=template&id=bd872baa&scoped=true"
import script from "./aftersaleDetails.vue?vue&type=script&lang=ts"
export * from "./aftersaleDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd872baa",
  null
  
)

export default component.exports